/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LayoutOption/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function LayoutOption({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/LayoutOptions/LayoutOption"
  
}) {
let layoutOptionNameValueData = fromData.useDataValue({ viewPath,
context: 'layout_option',
path: 'name',
})
let tabSelectedImagesLayoutValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.images.layout',
})
let layoutOptionIdValueData = fromData.useDataValue({ viewPath,
context: 'layout_option',
path: 'id',
})
let aggregateData = fromAggregate.equals(tabSelectedImagesLayoutValueData, layoutOptionIdValueData)
let layoutOptionItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'layout_option_item',
path: 'isFirst',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 marginLeft={layoutOptionItemIsFirstValueData ? "0px" : dtSpaceM}
 width="auto"
 paddingLeft={0}
 paddingRight={0}
 fontSize={14}
 colorActive={dtColorsNeutral800}
 data="layout_option.name"
 text={layoutOptionNameValueData}
 data="tab.selected.images.layout"
 data="layout_option.id"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 data="layout_option_item.isFirst"
/>
{children}
</React.Fragment>)
}